import { render, staticRenderFns } from "./SidebarItemChild.vue?vue&type=template&id=d2ca8692"
import script from "./SidebarItemChild.vue?vue&type=script&lang=js"
export * from "./SidebarItemChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2ca8692')) {
      api.createRecord('d2ca8692', component.options)
    } else {
      api.reload('d2ca8692', component.options)
    }
    module.hot.accept("./SidebarItemChild.vue?vue&type=template&id=d2ca8692", function () {
      api.rerender('d2ca8692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/SidebarItemChild.vue"
export default component.exports